function Comp14() {
    $(
        ".comp-14.compCollapse .compCollapse-toggle .btn, .comp-14-footer .btn"
    ).on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        $(".comp-14.compCollapse").toggleClass("show");
    });

    $(document).on(
        "click",
        ".comp-14-item-colors .comp-14-item-colors-circle",
        async (e) => {
            e.preventDefault();
            const text = (
                $(e.currentTarget).data("copy") || $(e.currentTarget).text()
            ).trim();

            if (navigator.clipboard && window.isSecureContext) {
                await navigator.clipboard.writeText(text);
            } else {
                const ta = $("<textarea>")
                    .val(text)
                    .css({ position: "fixed", opacity: 0 })
                    .appendTo("body");
                ta[0].select();
                document.execCommand("copy");
                ta.remove();
            }

            $(".copied-alert.default").addClass("show");
            setTimeout(
                () => $(".copied-alert.default").removeClass("show"),
                2000
            );
        }
    );
}
Comp14();
